import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner} from "@nextui-org/react";
import { track_uri } from "../../utils/url";
import { PATCH } from "../../utils/requests";
import { toast } from "react-toastify";

export default function Ereen_Batlah({ callback, pay, phone, id }) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);

  const handlecal = () => {
    callback();
  }

  const Submit = async () => {
    setLoad(true)
    const b = await PATCH({uri:track_uri +'/payment', data:{payment: pay, phoneNo: phone, id:id}});
    toast.success("Амжилттай балаллаа");
    handlecal();
    setLoad(false);
    Cancel();
  };

  const Cancel = () => {
    onOpenChange(false);
  };

  return (
    <>
      <Button size="sm" onPress={onOpen}>Батлах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Баталгаажуулах</ModalHeader>
              <ModalBody>
                <div>
                  <h1>Та баталгаажуулахдаа итгэлтэй байна уу ?</h1>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={Cancel}>
                  Үгүй
                </Button>
                {
                  load?
                  <Button color="primary">
                    Баталгаажуулж байна ... <Spinner/>
                  </Button>
                  :
                  <Button color="primary" onPress={Submit}>
                    Тийм
                  </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}